(function () {
  var shopmy_loaded = false;

  function loadShopMy() {
    if (shopmy_loaded) return;
    shopmy_loaded = true;

    var shopmy_script = document.createElement('script');
    shopmy_script.src = 'https://static.shopmy.us/Affiliates/sms_aff_clicktrack.js?domain=thebeast.com&expires=30';
    shopmy_script.async = true;
    document.head.appendChild(shopmy_script);
  }

  function marketingAllowed() {
    var privacy_api = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy_api) return false;
    return privacy_api.analyticsProcessingAllowed() && privacy_api.marketingAllowed();
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    if (event.detail.marketingAllowed) loadShopMy();
  });

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        if (marketingAllowed()) loadShopMy();
      }
    );
  }
})();